export const LICENSE_MANAGEMENT = 'license-management'
export const TRAINING_REPORT = 'training-report'
export const USER_MANAGEMENT = 'user-management'
